export default __webpack_public_path__ + "static/media/Comp 2_00030.a58b238b.png";